export default __webpack_public_path__ + "static/media/logout-blue.f9faa5e4.svg";